
// (function () {
//   'use strict';

//   var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once;
//   var KEY = 'fs-wishlist';

//   function readIds() {
//     try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
//   }
//   function writeIds(ids) {
//     try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) { /* storage unavailable */ }
//   }
//   function updateCount() {
//     var n = readIds().length;
//     qsa('[data-wishlist-count]').forEach(function (el) { el.textContent = n; el.dataset.count = n; });
//   }

//   function initWishlist(ctx) {
//     var ids = readIds();
//     qsa('[data-wishlist-toggle]', ctx).forEach(function (btn) {
//       if (!once(btn, 'Wishlist')) return;
//       var id = btn.dataset.wishlistProductId;
//       if (id && ids.indexOf(id) > -1) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
//       btn.addEventListener('click', function () {
//         if (!id) return;
//         var current = readIds();
//         var i = current.indexOf(id);
//         if (i > -1) { current.splice(i, 1); btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); }
//         else { current.push(id); btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
//         writeIds(current);
//         updateCount();
//       });
//     });
//     updateCount();
//   }

//   window.FS.initWishlist = initWishlist;
// })();

(function () {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('[data-pb-wishlist]');
    if (!link || event.defaultPrevented) return;
    if (!window.WishListHero_SDK || !window.WishListHero_SDK.OpenWishList) return;

    event.preventDefault();
    window.WishListHero_SDK.OpenWishList();
  });
})();
